/**
 * 媒体文件工具函数
 */

/**
 * 检测URL是否为视频文件
 * @param url 文件URL
 * @returns 是否为视频文件
 */
export function isVideoFile(url: string): boolean {
  if (!url) return false

  const videoExtensions = [
    '.mp4',
    '.avi',
    '.mov',
    '.mkv',
    '.webm',
    '.flv',
    '.wmv',
    '.m4v',
    '.3gp',
    '.ogv'
  ]
  const videoKeywords = ['video', 'mp4', 'avi', 'mov', 'mkv', 'webm']

  try {
    // 从URL中提取文件扩展名
    const urlLower = url.toLowerCase()

    // 检查扩展名
    for (const ext of videoExtensions) {
      if (urlLower.includes(ext)) {
        return true
      }
    }

    // 检查URL中是否包含视频相关的关键词
    for (const keyword of videoKeywords) {
      if (urlLower.includes(keyword)) {
        return true
      }
    }
  } catch (error) {
    console.warn('检测视频文件时出错:', error)
  }

  return false
}

/**
 * 检测媒体类型
 * @param url 文件URL
 * @param mediaType 媒体类型（如果已指定）
 * @returns 媒体类型
 */
export function detectMediaType(
  url: string,
  mediaType?: 'image' | 'video'
): 'image' | 'video' {
  if (mediaType) {
    return mediaType
  }

  return isVideoFile(url) ? 'video' : 'image'
}

/**
 * 获取媒体文件的默认封面（用于视频）
 * @param _videoUrl 视频URL
 * @returns 封面URL或null
 */
export function getVideoThumbnail(_videoUrl: string): string | null {
  // 这里可以添加获取视频封面的逻辑
  // 目前返回null，让浏览器使用默认封面
  return null
}
